import EventEmitter from 'events';

const cartServiceFactory = () => {
    const _eventEmitter = new EventEmitter();
    const notify = ({ type, args }) => {
        if (typeof window === 'undefined') {
            return;
        }
        const data = { action: type, args };

        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.ffi
        ) {
            window.webkit.messageHandlers.ffi.postMessage(data);
        }
        if (window.android && window.android.postMessage !== undefined) {
            window.android.postMessage(JSON.stringify(data));
        }

        // eslint-disable-next-line no-restricted-globals
        if (parent) {
            // eslint-disable-next-line no-restricted-globals
            parent.postMessage(
                {
                    event: type,
                    args,
                },
                '*',
            );
        }
    };

    const on = (eventName, handler) => _eventEmitter.on(eventName, handler);

    const off = (eventName, handler) =>
        _eventEmitter.removeListener(eventName, handler);

    const once = (eventName, handler) => _eventEmitter.once(eventName, handler);

    if (typeof window !== 'undefined') {
        window.addEventListener('message', (e) => {
            const data = e.data;

            if (data && data.event) {
                _eventEmitter.emit(data.event, data.payload);
            }
        });
    }

    return {
        notify,
        on,
        once,
        off,
    };
};

export default cartServiceFactory;
